import { OrderItemRow } from './order-items-utils';
import VariantAsyncTable from '@/components/variant/variant-async-table';

interface OrderItemsEditorProps {
  value: OrderItemRow[];
  onChange: (items: OrderItemRow[]) => void;
  hideAllItems?: boolean;
}

export function OrderItemsEditor({
  value,
  onChange,
  hideAllItems,
}: OrderItemsEditorProps) {
  const addItem = (variantId: string) => {
    const existingItem = value.find((i) => i.variantId === variantId);
    if (!existingItem) {
      onChange([...value, { variantId, quantity: 1 }]);
    } else {
      updateQty(variantId, existingItem.quantity + 1);
    }
  };

  const updateQty = (variantId: string, quantity: number) => {
    onChange(
      value.map((i) => (i.variantId === variantId ? { ...i, quantity: Math.max(1, quantity) } : i)),
    );
  };

  const removeItem = (variantId: string) => {
    onChange(value.filter((i) => i.variantId !== variantId));
  };

  return (
    <div className="h-full flex flex-col">
      {!hideAllItems && (
        <div className="flex-1 min-h-0 rounded-lg border border-slate-200 overflow-hidden">
          <div className="h-full overflow-auto">
            <VariantAsyncTable
              onAdd={(row) => {
                addItem(String(row.id));
              }}
              cartItems={value}
              onUpdateQty={updateQty}
              onRemove={removeItem}
            />
          </div>
        </div>
      )}
    </div>
  );
}